<div class="spinner-container">
    <svg class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" cx="33" cy="33"
            r="30"></circle>
    </svg>
</div>